var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.183,
    height: 94.717,
    viewBox: "0 0 75.183 94.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14098",
    "data-name": "Group 14098",
    transform: "translate(0 1.943)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5279",
    "data-name": "Rectangle 5279",
    width: 75.183,
    height: 69.187,
    transform: "translate(0 23.587)",
    fill: "var(--secondaryColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11258",
    "data-name": "Path 11258",
    d: "M79.142,105.749a12.273,12.273,0,0,0-2.53,24.282v7.52a2.567,2.567,0,1,0,5.134,0v-7.539a12.271,12.271,0,0,0-2.6-24.264m0,19.4a7.135,7.135,0,1,1,7.135-7.135,7.135,7.135,0,0,1-7.135,7.135",
    transform: "translate(-41.553 -64.757)",
    fill: "var(--bgColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11259",
    "data-name": "Path 11259",
    d: "M79.485,42.721H36.764V21.361a21.361,21.361,0,1,1,42.721,0Zm-39.722-3H76.486V21.361a18.361,18.361,0,1,0-36.722,0Z",
    transform: "translate(-20.536 -1.943)",
    fill: "var(--secondaryColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.9500b81251f0b7a03e30b9a6a84600ea.svg";
export { ForwardRef as ReactComponent };